import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DrawtoolComponent } from './drawtool.component';
import { FormsModule } from '@angular/forms';
import { ColorPickerModule } from 'ngx-color-picker';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  declarations: [DrawtoolComponent],
  imports: [
    CommonModule,
    FormsModule,
    ColorPickerModule,
    NgbModule
  ],
  exports :[DrawtoolComponent]
})
export class DrawtoolModule { }
